import type { JSX } from "react";
import { IconChevron } from "../components/icons";

export function Pager({ page, hasMore, onPrev, onNext, loading }: {
  page: number; hasMore: boolean; onPrev: () => void; onNext: () => void; loading: boolean;
}): JSX.Element {
  return (
    <div className="cc-pager">
      <button className="cc-range" type="button" disabled={page === 0 || loading} onClick={onPrev}>
        <IconChevron size={13} style={{ transform: "rotate(90deg)" }} />
        上一页
      </button>
      <span className="cc-pager-label">第 {page + 1} 页</span>
      <button className="cc-range" type="button" disabled={!hasMore || loading} onClick={onNext}>
        下一页
        <IconChevron size={13} style={{ transform: "rotate(-90deg)" }} />
      </button>
    </div>
  );
}
